"use strict";

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Array$from = require("@babel/runtime-corejs2/core-js/array/from");
var _Symbol = require("@babel/runtime-corejs2/core-js/symbol");
var _Symbol$iterator = require("@babel/runtime-corejs2/core-js/symbol/iterator");
var _Array$isArray = require("@babel/runtime-corejs2/core-js/array/is-array");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _querystring = _interopRequireDefault(require("querystring"));
var _uuid = _interopRequireDefault(require("uuid"));
var _webexCore = require("@webex/webex-core");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof _Symbol !== "undefined" && o[_Symbol$iterator] || o["@@iterator"]; if (!it) { if (_Array$isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var Team = _webexCore.WebexPlugin.extend({
  namespace: 'Team',
  /**
   * Move an existing group conversation into a team.
   * @param {TeamObject} team
   * @param {ConversationObject} conversation
   * @param {Object} activity Reference to the activity that will eventually be
   * posted. Use this to (a) pass in e.g. clientTempId and (b) render a
   * provisional activity
   * @returns {Promise} Resolves with the add activity
   */
  addConversation: function addConversation(team, conversation, activity) {
    var _this = this;
    return this._ensureGeneralConversation(team).then(function (generalConversation) {
      return _this.webex.internal.conversation.prepare(activity, {
        verb: 'add',
        target: _this.webex.internal.conversation.prepareConversation(generalConversation),
        object: {
          id: conversation.id,
          objectType: 'conversation'
        },
        kmsMessage: {
          method: 'create',
          uri: '/authorizations',
          resourceUri: conversation.kmsResourceObjectUrl,
          userIds: [generalConversation.kmsResourceObjectUrl]
        }
      });
    }).then(function (a) {
      return _this.webex.internal.conversation.submit(a);
    });
  },
  /**
   * Add a member to a team
   * @param {TeamObject} team
   * @param {Object} participant
   * @param {Object} activity Reference to the activity that will eventually be
   * posted. Use this to (a) pass in e.g. clientTempId and (b) render a
   * provisional activity
   * @returns {Promise} Resolves with activity that was posted
   */
  addMember: function addMember(team, participant, activity) {
    var _this2 = this;
    return this._ensureGeneralConversation(team).then(function (generalConversation) {
      return _this2.webex.internal.conversation.add(generalConversation, participant, activity);
    });
  },
  /**
   * Create a team
   * @param {NewTeamObject} params
   * @param {string} params.displayName
   * @param {string} params.summary
   * @param {Array} params.participants
   * @returns {Promise} Resolves with the created team
   */
  create: function create(params) {
    var _this3 = this;
    if (!params.displayName) {
      return _promise.default.reject(new Error('`params.displayName` is required'));
    }
    if (!params.participants || params.participants.length === 0) {
      return _promise.default.reject(new Error('`params.participants` is required'));
    }
    return _promise.default.all(params.participants.map(function (participant) {
      return _this3.webex.internal.user.asUUID(participant, {
        create: true
      });
    })).then(function (participants) {
      participants.unshift(_this3.webex.internal.device.userId);
      params.participants = (0, _uniq2.default)(participants);
    }).then(function () {
      return _this3._prepareTeam(params);
    }).then(function (payload) {
      return _this3.webex.request({
        method: 'POST',
        service: 'conversation',
        resource: 'teams',
        body: payload
      });
    }).then(function (res) {
      return res.body;
    });
  },
  /**
   * Create a conversation within a team. Currently does not support
   * activities besides add (ie no post or share activities).
   * @param {TeamObject} team
   * @param {NewConversationObject} params
   * @param {string} params.displayName
   * @param {string} params.summary
   * @param {Array} params.participants
   * @param {Object} options
   * @param {boolean} options.includeAllTeamMembers
   * @returns {Promise} Resolves with the newly created conversation
   */
  createConversation: function createConversation(team, params) {
    var _this4 = this;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!team.url) {
      return _promise.default.reject(new Error('`team.url` is required'));
    }
    if (!params.displayName) {
      return _promise.default.reject(new Error('`params.displayName` is required'));
    }
    return this._ensureGeneralConversation(team).then(function (generalConversation) {
      return _promise.default.all(params.participants.map(function (participant) {
        return _this4.webex.internal.user.asUUID(participant, {
          create: true
        });
      })).then(function (participants) {
        participants.unshift(_this4.webex.internal.device.userId);
        params.participants = (0, _uniq2.default)(participants);
      }).then(function () {
        return _this4._prepareTeamConversation(generalConversation, params);
      });
    }).then(function (payload) {
      return _this4.webex.request({
        method: 'POST',
        uri: "".concat(team.url, "/conversations"),
        qs: (0, _pick2.default)(options, 'includeAllTeamMembers'),
        body: payload
      });
    }).then(function (res) {
      return res.body;
    });
  },
  /**
   * Retrieve a single team
   * @param {Object|Team~TeamObject} team
   * @param {string} team.url
   * @param {Object} options
   * @param {boolean} options.includeTeamConversations
   * @param {boolean} options.includeTeamMembers
   * @returns {Promise} Resolves with the requested team
   */
  get: function get(_ref) {
    var _this5 = this;
    var url = _ref.url;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!url) {
      return _promise.default.reject(new Error('`team.url` is required'));
    }
    var params = _objectSpread({
      includeTeamConversations: false,
      includeTeamMembers: false
    }, options);
    return this.webex.request({
      uri: url,
      qs: params
    }).then(function (res) {
      return _this5._recordUUIDs(res.body).then(function () {
        return res.body;
      });
    });
  },
  /**
   * Get the list of conversations for a particular team
   * @param {TeamObject} team
   * @param {String} team.url
   * @returns {Promise} Resolves with an array of conversations
   */
  listConversations: function listConversations(_ref2) {
    var url = _ref2.url;
    if (!url) {
      return _promise.default.reject(new Error('`team.url` is required'));
    }
    return this.webex.request({
      uri: "".concat(url, "/conversations")
    }).then(function (res) {
      return res.body.items;
    });
  },
  /**
   * Join a team conversation
   * @param {TeamObject} team
   * @param {ConversationObject} conversation
   * @param {userId} userId
   * @returns {Promise} Resolves with the conversation
   */
  joinConversation: function joinConversation(team, conversation, userId) {
    if (!userId) {
      return _promise.default.reject(new Error('`userId` is required'));
    }
    var body = {
      kmsMessage: {
        client: {
          clientId: this.webex.internal.device.url,
          credential: {
            bearer: this.webex.credentials.supertoken.access_token,
            userId: userId
          }
        },
        method: 'create',
        requestId: _uuid.default.v4(),
        resourceUri: conversation.kmsResourceObjectUrl,
        uri: '/authorizations',
        userIds: [userId]
      }
    };
    return this.webex.request({
      method: 'POST',
      uri: "".concat(team.url, "/conversations/").concat(conversation.id, "/participants"),
      body: body
    }).then(function (res) {
      return res.body;
    });
  },
  /**
   * Retrieve all teams
   * @param {Object} options
   * @param {boolean} options.includeTeamConversations
   * @param {boolean} options.includeTeamMembers
   * @returns {Promise} Resolves with the requested teams
   */
  list: function list() {
    var _arguments = arguments,
      _this6 = this;
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var options, params, resource, res, list, results, _iterator, _step, result;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            options = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
            params = _objectSpread({
              includeTeamConversations: false,
              includeTeamMembers: false
            }, options);
            resource = 'teams';
            _context.next = 5;
            return _this6.webex.request({
              api: 'conversation',
              resource: resource,
              qs: params
            });
          case 5:
            res = _context.sent;
            list = res.body.items.slice(0);
            if (!res.body.additionalUrls) {
              _context.next = 13;
              break;
            }
            _context.next = 10;
            return _promise.default.all(res.body.additionalUrls.map(function (host) {
              var uri = "".concat(host, "/").concat(resource);
              return _this6.webex.request({
                uri: uri,
                qs: params
              });
            }));
          case 10:
            results = _context.sent;
            _iterator = _createForOfIteratorHelper(results);
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                result = _step.value;
                if (result.body && result.body.items && result.body.items.length) {
                  list = list.concat(result.body.items);
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          case 13:
            _context.next = 15;
            return _promise.default.all(res.body.items.map(function (team) {
              return _this6._recordUUIDs(team);
            }));
          case 15:
            return _context.abrupt("return", list);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  /**
   * Remove a member from a team
   * @param {TeamObject} team
   * @param {Object} participant
   * @param {Object} activity Reference to the activity that will eventually be
   * posted. Use this to (a) pass in e.g. clientTempId and (b) render a
   * provisional activity
   * @returns {Promise} Resolves with activity that was posted
   */
  removeMember: function removeMember(team, participant, activity) {
    var _this7 = this;
    return this._ensureGeneralConversation(team).then(function (generalConversation) {
      return _this7.webex.internal.conversation.leave(generalConversation, participant, activity);
    });
  },
  /**
   * Remove a team conversation from a team.
   * @param {TeamObject} team
   * @param {ConversationObject} conversation to be removed
   * @param {Object} activity Reference to the activity that will eventually be
   * posted. Use this to (a) pass in e.g. clientTempId and (b) render a
   * provisional activity
   * @returns {Promise} Resolves with the leave activity
   */
  removeConversation: function removeConversation(team, conversation, activity) {
    var _this8 = this;
    return this._ensureGeneralConversation(team).then(function (generalConversation) {
      var properties = {
        verb: 'remove',
        object: (0, _pick2.default)(conversation, 'id', 'url', 'objectType'),
        target: (0, _pick2.default)(generalConversation, 'id', 'url', 'objectType'),
        kmsMessage: {
          method: 'delete',
          uri: "<KRO>/authorizations?".concat(_querystring.default.stringify({
            authId: conversation.id
          }))
        }
      };
      return _this8.webex.internal.conversation.prepare(activity, properties);
    }).then(function (a) {
      return _this8.webex.internal.conversation.submit(a);
    });
  },
  /**
   * Update the displayName, summary, or teamColor field for a team.
   * @param {TeamObject} team to be updated
   * @param {Object} object with updated displayName, summary, and/or teamColor
   * @param {Object} activity Reference to the activity that will eventually be
   * posted. Use this to (a) pass in e.g. clientTempId and (b) render a
   * provisional activity
   * @returns {Promise} Resolves with posted activity
   */
  update: function update(team, object, activity) {
    return this.webex.internal.conversation.update(team, object, activity);
  },
  /* eslint-disable require-jsdoc */_ensureGeneralConversation: function _ensureGeneralConversation(team) {
    if (!team.generalConversationUuid) {
      return _promise.default.reject(new Error('`team.generalConversationUuid` must be present'));
    }
    if (team.conversations.items.length) {
      var generalConversation = (0, _find2.default)(team.conversations.items, {
        id: team.generalConversationUuid
      });
      if (generalConversation) {
        return _promise.default.resolve(generalConversation);
      }
    }
    return this.webex.internal.conversation.get({
      id: team.generalConversationUuid
    });
  },
  _prepareTeam: function _prepareTeam(params) {
    var payload = this.webex.internal.conversation._prepareConversationForCreation(params);
    payload.objectType = 'team';
    if (params.summary) {
      payload.summary = params.summary;
    }
    return _promise.default.resolve(payload);
  },
  _prepareTeamConversation: function _prepareTeamConversation(teamConversation, params) {
    if (!teamConversation.kmsResourceObjectUrl) {
      return _promise.default.reject(new Error('Team general conversation must have a KRO'));
    }
    var payload = this.webex.internal.conversation._prepareConversationForCreation(params);

    // Push the general conversation KRO on so that team members can
    // decrypt the title of this open room without joining it.
    payload.kmsMessage.userIds.push(teamConversation.kmsResourceObjectUrl);
    return _promise.default.resolve(payload);
  },
  _recordUUIDs: function _recordUUIDs(team) {
    var _this9 = this;
    if (!team.teamMembers || !team.teamMembers.items) {
      return _promise.default.resolve(team);
    }
    return _promise.default.all(team.teamMembers.items.map(function (participant) {
      // ROOMs or LYRA_SPACEs do not have email addresses, so there's no point attempting to
      // record their UUIDs.
      if (participant.type === 'ROOM' || participant.type === 'LYRA_SPACE') {
        return _promise.default.resolve();
      }
      return _this9.webex.internal.user.recordUUID(participant).catch(function (err) {
        return _this9.logger.warn('Could not record uuid', err);
      });
    }));
  } /* eslint-enable require-jsdoc */,
  version: "2.59.8"
});

/**
 * Assign or unassign a team member to be a moderator of a team
 * @param {TeamObject} team
 * @param {Object} participant
 * @param {Object} activity
 * @returns {Promise} Resolves with activity that was posted
 */
['assignModerator', 'unassignModerator'].forEach(function (verb) {
  Team.prototype[verb] = function submitModerationChangeActivity(team, member, activity) {
    var _this10 = this;
    return this._ensureGeneralConversation(team).then(function (teamConversation) {
      return _this10.webex.internal.conversation[verb](teamConversation, member, activity);
    });
  };
});

/**
 * Archive or unarchive a team or team conversation.
 * @param {TeamObject|ConversationObject} target team or team conversation that should be archived
 * @param {Object} activity Reference to the activity that will eventually be
 * posted. Use this to (a) pass in e.g. clientTempId and (b) render a
 * provisional activity
 * @returns {Promise} Resolves with the posted activity
 */
['archive', 'unarchive'].forEach(function (verb) {
  Team.prototype[verb] = function submitArchiveStateChangeActivity(target, activity) {
    var _this11 = this;
    if (!target.objectType) {
      return _promise.default.reject(new Error('`target.objectType` is required'));
    }
    var properties = {
      verb: verb,
      object: (0, _pick2.default)(target, 'id', 'url', 'objectType'),
      target: (0, _pick2.default)(target, 'id', 'url', 'objectType')
    };
    var teamUrl = this.webex.internal.conversation.getConvoUrl(target);
    return this.webex.internal.conversation.prepare(activity, properties).then(function (a) {
      return _this11.webex.internal.conversation.submit(a, teamUrl);
    });
  };
});
var _default = Team;
exports.default = _default;
//# sourceMappingURL=team.js.map
